import * as Yup from 'yup';
import { useFormik } from 'formik';

export const useFacilityProviderForm = ({ practice, onSubmit, validate }) => {
  const schema = Yup.object().shape({
    practice_id: Yup.number().required('Practice is required'),
    facility_name: Yup.string().required('Facility name is required'),
    facility_npi: Yup.string().required('Facility NPI is required'),
    facility_id: Yup.string().matches(/^\d+$/, 'Facility atypical ID must contain only numbers'),
    facility_addr_1: Yup.string().required('Address line 1 is required'),
    facility_addr_2: Yup.string().required(
      'Address line 2 is required. Enter N/A if not applicable'
    ),
    facility_city: Yup.string().required('City is required'),
    facility_state: Yup.string().required('State is required'),
    facility_zip: Yup.string()
      .min(9, 'Zip code must be 9 digits')
      .max(9, 'Zip code must be 9 digits')
      .required('Zip code is required (9 digits)'),
    facility_phone: Yup.string().matches(/^\d+$/, 'Phone must contain only numbers')
  });

  return useFormik({
    enableReinitialize: true,
    initialValues: {
      id: practice?.facility_id ?? null,
      practice_id: practice?.id,
      facility_name: practice?.name ?? '',
      facility_npi: practice?.facility_npi ?? '',
      facility_id: practice?.facility_atypical ?? '',
      facility_addr_1: practice?.practiceAddress?.address_ln_1 ?? '',
      facility_addr_2: practice?.practiceAddress?.address_ln_2 ?? '',
      facility_city: practice?.practiceAddress?.city ?? '',
      facility_state: practice?.practiceAddress?.state ?? '',
      facility_zip: practice?.practiceAddress?.zip.replace(/-/g, '')
    },
    validationSchema: validate ? schema : undefined,
    onSubmit
  });
};
